<template>
  <div class="exchangeRateInfo">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :label="$t.meta.currency"
            label-class="number-label"
            :value="currencyStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('exchangeRateInfoCurrency')"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
              <van-button size="small" type="default" @click="onReset">{{
                $t.meta.reset
              }}</van-button>
            </template>
          </van-field>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.exchangeRateInfo.currency }}：{{ item.CurrencyStr }}
        </div>
        <div class="list-item">
          {{ $t.exchangeRateInfo.rate }}：{{ item.ExchangeRate }}
        </div>
        <div class="list-item">{{ $t.exchangeRateInfo.time }}：{{ item.CreateTime }}</div>
      </div>
    </van-list>

    <option-list
      event="exchangeRateInfoCurrency"
      :options="currencyList"
      @onSelect="onSelectCurrency"
    ></option-list>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail">{{
        $t.exchangeRateInfo.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field);

export default {
  name: "exchangeRateInfo",
  components: {
    OptionList,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      currency: "",
      currencyStr: "",
      currencyList: [],
    };
  },
  created() {
    this.getCurrencyList();
  },
  methods: {
    onSelectCurrency(item) {
      this.currency = item.value;
      this.currencyStr = item.text;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    gotoDetail() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "exchangeRateInfoDetail",
        name: "exchangeRateInfoDetail",
        query: [],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    onReset() {
      this.currency = "";
      this.currencyStr = "";
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        UserId: this.UserId,
        Currency: this.currency,
      };
      this.$api.financialManagement
        .getExchangeRateList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.exchangeRateInfo {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
